import { Injectable } from '@angular/core';

import { NavigationService } from '@core/services/navigation/navigation.service';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class LimitsCommand extends BaseProductCommand {
  readonly type = 'limits';
  readonly title = 'Лимиты';
  readonly icon = 'limit';
  readonly productType = ProductTypes.CARD;
  readonly isInfoAction = true;
  readonly settingsNames = ['REQUEST/UPDATE_CARD_LIMITS'];

  get order(): number {
    return this.getContextualOrder(
      {
        [ProductTypes.CARD]: 30 // Карты: Лимиты (3-й в списке "прочее")
      },
      999
    );
  }

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private navigationService: NavigationService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.navigationService.push(`product/${context.data.id}/card-limit`, {
      state: {
        number: context.data.cardNumber,
        productCurrencyCode: context.data.currencyCode
      }
    });
  }
}
